import { render, staticRenderFns } from "./Star4.vue?vue&type=template&id=3647f1a9&"
import script from "./Star4.vue?vue&type=script&lang=js&"
export * from "./Star4.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/one-stop-shop/one-stop-shop/one-stop-shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3647f1a9')) {
      api.createRecord('3647f1a9', component.options)
    } else {
      api.reload('3647f1a9', component.options)
    }
    module.hot.accept("./Star4.vue?vue&type=template&id=3647f1a9&", function () {
      api.rerender('3647f1a9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/wp-content/themes/global-theme/views/pages/productAside/Heading/stars/Star4.vue"
export default component.exports